import styled from 'styled-components';

/* Card "Economize até" do Figma: faixa colorida da marca no topo, valor em
 * laranja, detalhamento e o botão para a tela de Oportunidades. */

export const EconomyOportunitiesContainer = styled.div`
  flex: 1 1 380px;
  background-color: ${(props) => props.theme.color.bg.primary};
  border-top: 2px solid ${(props) => props.theme.color.ui.primary};
  padding: 24px 32px;
  font-family: ${(props) => props.theme.font.body.family};

  @media only screen and (max-width: 600px) {
    padding: 20px 16px;
  }
`;

export const Brand = styled.div`
  display: flex;
  gap: 3px;
  margin-bottom: 20px;

  i {
    display: block;
    width: 12px;
    height: 4px;
    transform: skewX(-20deg);
  }
  i:nth-child(1) {
    background: ${(props) => props.theme.color.ui.red};
  }
  i:nth-child(2) {
    background: ${(props) => props.theme.color.ui.orange};
  }
  i:nth-child(3) {
    background: ${(props) => props.theme.color.ui.yellow};
  }
  i:nth-child(4) {
    background: ${(props) => props.theme.color.ui.green};
  }
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;

  .headline {
    display: flex;
    align-items: baseline;
    gap: 10px;
    flex-wrap: wrap;
  }

  h2 {
    margin: 0;
    font-family: ${(props) => props.theme.font.title.family};
    font-size: 18px;
    font-weight: 600;
    color: ${(props) => props.theme.color.text.primary};
  }

  h1 {
    margin: 0;
    font-family: ${(props) => props.theme.font.title.family};
    font-size: 24px;
    font-weight: 700;
    color: ${(props) => props.theme.color.ui.orange};
  }

  span {
    font-size: 12px;
    color: ${(props) => props.theme.color.text.quaternary};
  }

  p {
    margin: 8px 0 12px;
    font-size: ${(props) => props.theme.font.body.size.small};
    color: ${(props) => props.theme.color.text.tertiary};
  }
`;

export const Breakdown = styled.ul`
  margin: 6px 0 0;
  padding-left: 18px;
  font-size: ${(props) => props.theme.font.body.size.small};
  color: ${(props) => props.theme.color.text.primary};

  b {
    color: ${(props) => props.theme.color.text.primary};
  }
`;
